<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="12">
                            <common-page-btn>
                                <a-button type="primary" :ghost="param.state !== ''"
                                    @click="stateChange('')">全部</a-button>
                                <a-button type="primary" :ghost="param.state !== 1"
                                    @click="stateChange(1)">已填写</a-button>
                                <a-button type="primary" :ghost="param.state !== 0"
                                    @click="stateChange(0)">未填写</a-button>
                            </common-page-btn>
                        </a-col>
                        <a-col span="12">
                            <a-row type="flex" justify="end" :gutter="3">
                                <a-col span="6">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="doRefresh"
                                        @on-clear="doRefresh" placeholder="关键词查询"></a-input>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="colId" :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">
                    <template slot-scope="row" slot="state">
                        <a-tag color="green" v-if="row.isUp">已填报</a-tag>
                        <a-tag color="red" v-else>未填报</a-tag>
                    </template>
                    <template slot-scope="row" slot="action">
                        <a-tooltip title="去填写" v-has="'collection:post'">
                            <a-button type="link" icon="form" :disabled="row.isUp"
                                @click="$refs.collectionFormRef.show(row)"></a-button>
                        </a-tooltip>
                        <a-tooltip title="查看详情">
                            <a-button type="link" icon="eye" :disabled="!row.isUp"
                                @click="$refs.collectionDetailRef.show(row.dataId)"></a-button>
                        </a-tooltip>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                    @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
        <a-back-top />
        <collection-form ref="collectionFormRef" @success="getList"></collection-form>
        <collection-detail ref="collectionDetailRef"></collection-detail>
    </div>
</template>

<script>
import apiUtil from "@/common/apiUtil";
import utils from '@/common/utils';
import collectionForm from "./components/collection-form.vue";
import collectionDetail from "@/views/customer/collection/components/collection-detail.vue";
export default {
    components: {
        collectionForm,
        collectionDetail
    },
    data() {
        return {
            data: [],
            loading: false,
            param: {
                page: 1,
                limit: 20,
                keyword: '',
                state: ''
            },
            organList: apiUtil.getOrganList(),
            keys: [
                { title: '任务名称', dataIndex: 'title', align: 'left', ellipsis: true },
                { title: '填报状态', scopedSlots: { customRender: 'state' }, width: 200, ellipsis: true },
                { title: '截止时间', dataIndex: 'overTime', width: 200, ellipsis: true },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ],
        };
    },
    created() {
        this.doRefresh();
    },
    methods: {
        stateChange(e) {
            // console.log(e)
            this.param.state = e;
            this.doRefresh();
        },
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/collection/query', this.param)
                .then(ret => {
                    // console.log(ret)
                    this.data = ret.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
